import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ExtrasStoreModule } from './store'

@NgModule({
  imports: [CommonModule, ExtrasStoreModule],
  exports: [ExtrasStoreModule],
})
export class ExtrasLibraryModule {}
